import React from 'react';

function Careers() {
  return (
    <div className="page">
      <h1>Careers</h1>
      <p>Join our team and build the future with Switch.</p>
    </div>
  );
}

export default Careers;
